import './PageItem.scss';

export { default } from './PageItem';
